export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6643.cb51a540.jpg";